import { combineReducers } from 'redux';
import lotteryAvailableTabsReducer from './lotteryAvailableTabsReducer';
import lotteryPageDataReducer from './lotteryPageDataReducer';
import lotteryPrizeDataReducer from './lotteryPrizeDataReducer';
import lotteryMyTicketsReducer from './lotteryMyTicketsReducer';
import lotterySerialDataReducer from './lotterySerialDataReducer';
import lotteryResultDrawsReducer from './lotteryResultDrawsReducer';
import lotteryOneOfSerialReducer from './lotteryOneOfSerialReducer';
import lotteryResultDrawActiveReducer from './lotteryResultDrawActiveReducer';
import lotterySlipReducer from './lotterySlipReducer';
import superLotterySlipReducer from './superLotterySlipReducer';
import lotterySpecialDataReducer from './lotterySpecialDataReducer';
import lotteryQueryResultReducer from './lotteryQueryResultReducer';
import lotteryBuyDataReducer from './lotteryBuyDataReducer';
import lotterySharedTicketsReducer from './lotterySharedTicketsReducer';
import lotteryRendererReducer from './lotteryRendererReducer';

export default combineReducers({
  lotteryAvailableTabs: lotteryAvailableTabsReducer,
  lotteryPageData: lotteryPageDataReducer,
  lotteryPrizeData: lotteryPrizeDataReducer,
  lotteryMyTickets: lotteryMyTicketsReducer,
  lotterySerialData: lotterySerialDataReducer,
  lotterySpecialData: lotterySpecialDataReducer,
  lotteryResultDraws: lotteryResultDrawsReducer,
  lotteryOneOfSerial: lotteryOneOfSerialReducer,
  lotteryResultDrawActive: lotteryResultDrawActiveReducer,
  lotteryQueryResult: lotteryQueryResultReducer,
  lotterySlipData: lotterySlipReducer,
  superLotterySlipData: superLotterySlipReducer,
  lotteryBuyData: lotteryBuyDataReducer,
  lotterySharedTickets: lotterySharedTicketsReducer,
  lotteryRenderer: lotteryRendererReducer
});
